import type { LoginRequest, LoginResponse, MeResponse } from '@dental/shared-types';
import { api } from './api';

export const AuthApi = {
  login: (body: LoginRequest) =>
    api.post<LoginResponse>('/auth/login', body, { skipAutoRefresh: true }),

  refresh: () => api.post<LoginResponse>('/auth/refresh', undefined, { skipAutoRefresh: true }),

  logout: () => api.post<void>('/auth/logout'),

  me: () => api.get<MeResponse>('/auth/me'),
};
